export default {"src":"/_next/static/media/bg_green.ef81258d.svg","height":605,"width":2200,"blurWidth":0,"blurHeight":0};